// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__EcFLX","log":"ModalInventoryLogs_log__3Jsae","date":"ModalInventoryLogs_date__sX2iQ","userName":"ModalInventoryLogs_userName__2W34c"};